// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-no-translate]{translate:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.PCGMz{margin-top:15px}.xe138{color:green;position:fixed;right:calc(50% - 35px);top:calc(50vh - 50px);z-index:1}.oUobT{margin:20px;padding:0 0 40px}.N6dcC{bottom:0;height:100px;left:0;margin:auto;position:absolute;right:0;top:0;width:100px;z-index:50}.sBA2T{color:red;float:left;margin:15px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"questionForm": "PCGMz",
	"fabProgress": "xe138",
	"container": "oUobT",
	"loadingWrapper": "N6dcC",
	"formError": "sBA2T"
};
module.exports = ___CSS_LOADER_EXPORT___;
